import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { ToggleLabelledComponent } from './toggle-labelled.component';

@NgModule({
    imports: [CommonModule, FormsModule, TranslateModule],
    exports: [ToggleLabelledComponent],
    declarations: [ToggleLabelledComponent]
})
export class ToggleLabelledModule {}
